export default function getTranslation(translations, key, defaultTranslation) {
  if (Array.isArray(translations)) {
    const translation = translations.find((item) => item.name === key);

    if (translation) {
      return translation.value;
    }
  }

  const fallbackTranslation =
    defaultTranslation !== undefined ? defaultTranslation : `Missing: ${key}`;
  return translations[key] || fallbackTranslation;
}
